export const isValidNumber = (input) => {
    const num = Number(input);

    if (isNaN(num)) {
        return false;
    }

    return Number.isInteger(num) && num >= 0 && num <= 10 && num !== 0;;
}

export const getFormatedValue = (num) => {
    if(num < 0){
        return 0
    }

    if(num > 10) {
        return 10
    }

    return num
}
